import { PRODUCTION_ADMIN_ORIGIN } from "@/utils/canonicalUrls";
import { shouldShowStagingAdminWarning } from "@/utils/deployEnvironment";

interface StagingAdminWarningProps {
  visible?: boolean;
}

export const StagingAdminWarning = ({
  visible = shouldShowStagingAdminWarning(),
}: StagingAdminWarningProps) => {
  if (!visible) {
    return null;
  }

  // Nav PRD §9, F-209: a 26px strip above the sidebar and main area.
  return (
    <aside
      aria-label="Staging environment warning"
      className="staging-admin-warning"
    >
      <span className="staging-admin-warning__message">
        Staging — nothing you do here reaches customers
      </span>
      <a
        className="staging-admin-warning__link"
        href={PRODUCTION_ADMIN_ORIGIN}
        rel="noopener noreferrer"
        target="_blank"
      >
        Open live Admin Portal
        <span className="vnext-sr-only"> (opens in a new tab)</span>
      </a>
    </aside>
  );
};

export default StagingAdminWarning;
